import { WordSearchConfig } from '@/typings/customilyElements/canvasElements';

const baseUrl = process.env.VUE_APP_CUSTOMILY_STOREFRONT_SERVICE_API_URL;

export const generateWordSearchPuzzleImage = async (
    words: string[],
    options: WordSearchConfig
): Promise<{ seed: string; base64: string }> => {
    const body = {
        words: words,
        options: options
    };

    const response = await fetch(`${baseUrl}/word-search-puzzle-generator/generate`, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
            'Content-Type': 'application/json'
        }
    });

    if (!response.ok) {
        let messageValue = '';

        try {
            const error = await response.json();
            try {
                const parsedMessage = JSON.parse(error.message) as {
                    error: { message: string };
                };
                messageValue = parsedMessage?.error?.message;
            } catch {
                messageValue = error.message;
            }
        } catch {
            // Backend returned non-JSON (HTML/plain text)
            messageValue = await response.text();
        }

        const message = `Failed to generate word search puzzle: ${messageValue || response.statusText}`;
        throw new Error(message);
    }

    return await response.json();
};
